import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BatchService } from 'src/app/private/services/batch.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-delete-batch',
  imports: [SharedModule],
  templateUrl: './delete-batch.component.html',
  styleUrl: './delete-batch.component.scss'
})
export class DeleteBatchComponent {
  @Input() batchData: any;
  @Output() closeDialog = new EventEmitter();
  @Output() reload = new EventEmitter();

  btnLoading = false;

  constructor(
    private api: BatchService,
    private messageService: MessageService
  ) { }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  onDelete() {
    this.btnLoading = true;
    this.api.deleteBatch(this.batchData.id).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Batch deleted successfully!'
        });
        this.reload.emit();
        this.handleCloseDialog();
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error.message || 'Something went wrong!'
        });
      },
      complete: () => {
        this.btnLoading = false;
      }
    });
  }
}